import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { Helper } from '../services/Helper';
import { UpdateProfile } from '../models/UpdateProfile';
import { ToastController, LoadingController, Platform } from '@ionic/angular';
import { APIService } from '../services/APIService';
import * as moment from 'moment';
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  credentialsForm: FormGroup;
  Regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  updateInfo: UpdateProfile;

  tokenData :any;
  firstname :any;
  lastname :any;
  email :any;
  phone :any;
  gender :any;
  dob :any;
  loader:any;


  constructor(private formBuilder: FormBuilder, private router:Router, private storage:Storage,private helper:Helper,public loadingController: LoadingController,private apiservice: APIService, private platform:Platform) {

    this.credentialsForm = this.formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: ['', Validators.compose([Validators.required])],
      email: ['', [Validators.required, Validators.email]],
      mobile: [
        '', Validators.compose([
          Validators.pattern(this.Regex),
          Validators.required
        ])
      ],
    });

    this.updateInfo = new UpdateProfile();

  }


  ionViewWillEnter(){


    this.platform.backButton.subscribeWithPriority(1, () => {
      this.router.navigate(['tabs/tab1']);
});



            this.storage.get('tokenData').then((val) => {
              console.log('tokenData', val);
              if (!val) {
                  this.router.navigate(["login"]);
              }
              else{


                this.storage.get('tokenData').then((tokenData) => {
                  this.storage.get('firstname').then((firstname) => {
                    this.storage.get('lastname').then((lastname) => {
                      this.storage.get('email').then((email) => {
                        this.storage.get('phone').then((phone) => {
                          this.storage.get('gender').then((gender) => {
                            this.storage.get('dob').then((dob) => {
            
                            this.tokenData =tokenData;
                            this.firstname =firstname;
                            this.lastname =lastname;
                            this.email =email;
                            this.phone =phone;
                            this.gender =gender;
                            this.dob =dob;
            
                  
                      });
                    });
                  });
                });
              });
            });
            });
   
              }      
            });    

  }



  ngOnInit() {
  }


  update(value:any){
    console.log(value);
    if (!value.firstname || !this.credentialsForm.controls.firstname) {
      this.helper.presentToast('Please Enter First Name!');  }
    else if(!value.lastname || !this.credentialsForm.controls.lastname) {
      this.helper.presentToast('Please Enter Last Name!'); }
    else if (!value.email || !this.credentialsForm.controls.email) {
      this .helper.presentToast('Please Enter Email address!'); }
    else if (!value.mobile || !this.credentialsForm.controls.mobile) {
      this.helper.presentToast('Please Enter Mobile Number!'); }
      else if (!this.gender ) {
        this.helper.presentToast('Please Enter gender'); }
        else if (!this.dob ) {
          this.helper.presentToast('Please Enter date of Birth'); }
else{
  this.updateInfo.firstname=value.firstname;
  this.updateInfo.lastname=value.lastname;
  this.updateInfo.fullname= value.firstname+ value.lastname;
  this.updateInfo.dob=this.dob;

  this.updateInfo.email=value.email;
  this.updateInfo.phone=value.mobile;
  this.updateInfo.gender=this.gender;
  this.updateInfo._id=this.tokenData;


  var a = moment();
  var b = moment(this.dob).format('YYYY-MM-DD');
  var age = moment.duration(a.diff(b));
  var years = age.years();
  var months = age.months();

  this.updateInfo.age = years + " years " + months + " months ";
  this.updateInfo.dob = formatDate(this.dob, 'yyyy-MM-dd', 'en-US');

  console.log(this.updateInfo);
  this.presentLoading().then(() => {
    this.apiservice.updatePatent(this.updateInfo).subscribe(
        response => {

          this.storage.set('email', this.updateInfo.email);
          this.storage.set('dob', this.updateInfo.dob);
          this.storage.set('age', this.updateInfo.age);
          this.storage.set('gender', this.updateInfo.gender);
          this.storage.set('firstname', this.updateInfo.firstname);
          this.storage.set('lastname', this.updateInfo.lastname);
          this.storage.set('phone', this.updateInfo.phone);



          this.dismissLoading();
          this.helper.presentToast("Profile Updated Successfully");
        }, error => {
            this.dismissLoading();
            this.helper.presentToastError('Something went wrong');
        });
  });
  
}
  }


  async presentLoading() {
    this.loader = await this.loadingController.create({
        translucent: true
    });
    await this.loader.present();
}

  async dismissLoading() {
    await this.loader.dismiss();
  }




}
